export function StepStartIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='22' height='16' viewBox='0 0 22 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M0 4C0 1.79086 1.79086 9.75943e-07 4 2.17983e-06L14 7.62939e-06L22 8.00001L14 16H4C1.79086 16 0 14.2091 0 12V4Z'
        fill='currentColor'
      />
    </svg>
  )
}
